import { Component, Input } from '@angular/core';
import { ModalService } from '../../../services';

@Component({
  selector: 'app-tech-support-modal',
  templateUrl: './tech-support-modal.component.html',
  styleUrls: ['./tech-support-modal.component.scss'],
})
export class TechSupportModalComponent {
  @Input() modalData: any;

  constructor(private modalService: ModalService) { }

  closeModal() {
    this.modalService.close();
  }
}
